import { combineReducers } from 'redux';

import LogIn from './containers/LogIn/reducers';

const rootReducer = combineReducers({ LogIn });

export default rootReducer;
